export function ToggleSwitch({
  checked = false,
  onChange,
  leftTitle = "",
  rightTitle = "",
  className
}) {
  const handleToggle = () => {
    if (onChange) onChange(!checked);
  };

  return (
    <div
    className={className}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        cursor: "pointer",
        userSelect: "none",
      }}
      onClick={handleToggle}
      role="switch"
      aria-checked={checked}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleToggle();
        }
      }}
    >
      {leftTitle && <span>{leftTitle}</span>}
      <div
        className={`toggle-switch ${checked ? "on" : "off"}`}
        style={{
          width: "48px",
          height: "20px",
          borderRadius: "999px",
          backgroundColor: checked ? "var(--primary-600)" : "#ccc",
          position: "relative",
          transition: "background-color 0.2s ease",
          padding: "2px",
          flexShrink: 0,
        }}
      >
        <div
          className="switch-ball"
          style={{
            height: "20px",
            width: "20px",
            borderRadius: "50%",
            backgroundColor: "#fff",
            transition: "transform 0.2s ease",
            transform: checked ? "translateX(28px)" : "translateX(0)",
          }}
        />
      </div>
      {rightTitle && <span>{rightTitle}</span>}
    </div>
  );
}
